import { Link } from "react-router-dom";
import { glossary } from "@/mocks/content";

const principles = [
  "信息标注来源，事实与推测清晰分层",
  "不做针对个人隐私与名誉的传播",
  "观点归属明确，拒绝匿名站队",
  "鼓励回到一手信源交叉验证",
  "发现偏差会勘误，并保留修订记录",
];

export default function Principles() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2">
          {/* 原则 */}
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">
              编辑守则 · OUR CODE
            </p>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              整理，也是一种负责的立场
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              我们不生产情绪，只生产「可查证的秩序」。以下守则，是我们整理每一条路线时的底线。
            </p>
            <ul className="mt-6 space-y-3">
              {principles.map((p) => (
                <li
                  key={p}
                  className="flex items-start gap-3 rounded-lg bg-background-50 px-4 py-3 text-sm text-foreground-700"
                >
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-800">
                    <i className="ri-check-line text-xs" aria-hidden="true"></i>
                  </span>
                  {p}
                </li>
              ))}
            </ul>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-1.5 text-sm font-medium text-primary-700 hover:text-primary-800"
            >
              了解我们是谁
              <i className="ri-arrow-right-line" aria-hidden="true"></i>
            </Link>
          </div>

          {/* 识瓜词典 */}
          <div>
            <div className="flex items-end justify-between">
              <div>
                <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">
                  识瓜词典 · GLOSSARY
                </p>
                <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950">
                  看懂讨论的基本词
                </h2>
              </div>
              <Link
                to="/methodology"
                className="hidden shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 hover:text-primary-800 sm:inline-flex"
              >
                完整词典与防骗指南
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </Link>
            </div>
            <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {glossary.slice(0, 6).map((g) => (
                <div
                  key={g.word}
                  className="rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-accent-200"
                >
                  <div className="flex items-center gap-2">
                    <span className="font-heading text-base font-bold text-foreground-900">{g.word}</span>
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-[10px] text-secondary-900">
                      {g.type}
                    </span>
                  </div>
                  <p className="mt-2 text-xs leading-relaxed text-foreground-600">{g.def}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}